import { Button, Flex, Image, Text, useColorModeValue, Icon, IconButton, Tooltip } from "@chakra-ui/react";
import React from "react";
import { Player } from "@lottiefiles/react-lottie-player";
import { Link } from "react-router-dom";
import { MdSupport } from "react-icons/md";

export default function SidebarDocs({ isCollapsed }) {
  const bgColor = useColorModeValue("#f6ad55", "white");
  const txColor = useColorModeValue("white", "black");

  const borderColor = useColorModeValue("#f6ad55", "navy.800");

  if (isCollapsed) {
    return (
      <Tooltip
        label="Contact Support"
        placement="right"
        hasArrow
        bg="gray.700"
        color="white"
        fontSize="sm"
        px={3}
        py={2}
        borderRadius="md"
      >
        <Link to="/dashboard/support">
          <Flex
            justify="center"
            align="center"
            bg={bgColor}
            borderRadius="12px"
            w="45px"
            h="45px"
            mx="auto"
            _hover={{ bg: "rgba(246, 173, 85, 0.8)" }}
            cursor="pointer"
          >
            <Icon as={MdSupport} w={6} h={6} color={txColor} />
          </Flex>
        </Link>
      </Tooltip>
    );
  }

  return (
    <Flex
      justify="center"
      direction="column"
      align="center"
      bg={bgColor}
      borderRadius="30px"
      me="20px"
      position="relative"
    >
      <Flex
        direction="column"
        mb="12px"
        align="center"
        justify="center"
        px="15px"
        pt="20px"
      >
        <Text
          fontSize={{ base: "lg", xl: "18px" }}
          color={txColor}
          fontWeight="bold"
          lineHeight="150%"
          textAlign="center"
          px="10px"
          mb="14px"
        >
          Need help?
        </Text>
        <Flex>
          <Player
            autoplay
            loop
            src="https://assets10.lottiefiles.com/packages/lf20_ssaoeg55.json"
            style={{ height: "100px", width: "150px" }}
          ></Player>
        </Flex>
      </Flex>
      <Link to="/dashboard/support">
        <Button
          bg="whiteAlpha.300"
          _hover={{ bg: "whiteAlpha.200" }}
          _active={{ bg: "whiteAlpha.100" }}
          mb={{ sm: "16px", xl: "24px" }}
          color={txColor}
          fontWeight="regular"
          fontSize="sm"
          minW="185px"
          mx="auto"
        >
          Contact Support
        </Button>
      </Link>
    </Flex>
  );
}
